jQuery(document).ready(function(){
    var $ = jQuery;
    let subscriptionBtns = $(".single-subscription");

    if(document.getElementById('card-element'))
    {
        initStripe();
    }

    // enable popovers
    $(function () {
        $('[data-toggle="popover"]').popover({html:true})
    })

    function equalHeight(resize, elements) {
        var allHeights = [],
        i = 0;
        if(resize === true){
            for(i = 0; i < elements.length; i++){
                elements[i].style.height = 'auto';
            }
        }
        for(i = 0; i < elements.length; i++){
            var elementHeight = elements[i].clientHeight;
            allHeights.push(elementHeight);
        }
        for(i = 0; i < elements.length; i++){
            elements[i].style.height = Math.max.apply( Math, allHeights) + 'px';
            // Optional: Add show class to prevent FOUC
            if(resize === false){
                elements[i].className = elements[i].className + " show";
            }
        }
    }

    // subscription-settings elements that need to be same height
    var addOnsH6 = document.getElementsByClassName("equalHeightAddOn");

    // single-bundle elements that need to be same height
    var bundleH3 = document.getElementsByClassName("equalHeightH3");
    var bundleP = document.getElementsByClassName("equalHeightP");

    // Equal Heights
    window.onload = function(){
        equalHeight(true, addOnsH6);
        equalHeight(true, bundleH3);
        equalHeight(true, bundleP);
    }

    window.onresize = function(){
        equalHeight(true, addOnsH6);
        equalHeight(true, bundleH3);
        equalHeight(true, bundleP);
    }

    // function for toggling active subscription on main account page
    $(subscriptionBtns).on('click', function(e){
        let subscription_to_show = e.currentTarget.dataset.subscription;
        $(".single-subscription").removeClass("active");

        e.currentTarget.classList.add("active");
        
        equalHeight(true, bundleH3);
        equalHeight(true, bundleP);

        if( $('body').hasClass('my-orders') )
        {
            $(".crate-status").addClass('d-none').removeClass('d-block');
            $(".crate-status[data-subscription='"+subscription_to_show+"']").removeClass('d-none').addClass('d-block');
        }
        else
        {
            jQuery(".equalHeightAddOn").removeAttr("style")
            $(".subscription-container").removeClass('active');
            $("#subscription-container-" + subscription_to_show).addClass('active');
            equalHeight(true, addOnsH6);
        }
    });

    subscriptionBtns.first().trigger('click');
    
    $("#noUpsell").click(function(){
        hideUpsellModal();
    });
});

function hideUpsellModal()
{
    const actionUrl = '/wp-admin/admin-ajax.php';
    const postData = {
        'action': 'hide_upsell_modal'
    }
    submitAjaxForm( actionUrl, postData );
}

function updateTotal()
{
    let basePrice = jQuery("#boxSize").find(":selected").data('price');
    if(typeof basePrice === 'undefined')
    {
        return false;
    }

    let drinkPrice = jQuery("#drinkAddon").is(':checked') ? jQuery("#drinkAddon").data('price') : 0;

    let grandTotal = (basePrice + drinkPrice).toFixed(2);
    jQuery("#total").text(grandTotal);

    /*
    if( jQuery("#userStateEdit-addSub").val() == 'FL' && jQuery("#userZipEdit").val() != '' )
    {
        jQuery.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: "POST",
            beforeSend: function(xhr){
                xhr.setRequestHeader('csrf_token', jQuery('meta[name="csrf-token"]').attr('content'));
            },
            data: {
                'zip': jQuery("#userZipEdit").val(),
                'action': 'sc_get_tax',
            },
            dataType: 'json',
            success: function(response) {
                taxTotal = parseFloat( (grandTotal * response.data.results[0].taxSales).toFixed(2) );

                let newTotal = parseFloat(grandTotal) + taxTotal;
                
                jQuery("#total").text(newTotal);
            }
        });
    }
    */
}


function countryChange(e, state_select_id)
{
    let newCountry = e.value;
    console.log(newCountry);

    jQuery.ajax({
        url: '/wp-admin/admin-ajax.php',
        type: "POST",
        beforeSend: function(xhr){
            xhr.setRequestHeader('csrf_token', jQuery('meta[name="csrf-token"]').attr('content'));
        },
        data: {
            'country_code': newCountry,
            'action': 'sc_get_states',
        },
        dataType: 'json',
        success: function(response) {
            console.log('Success: ', response);
            console.log(typeof response.data);
            
            if(typeof response.data === 'object')
            {
                let state_select = document.getElementById(state_select_id);
                console.log(state_select);
                state_select.disabled = false;
                state_select.innerHTML = '';

                let blank_option = document.createElement('option');
                blank_option.innerHTML = '-- select --';
                state_select.appendChild(blank_option);

                for (const abbreviation in response.data) 
                {
                    let state_option = document.createElement('option');
                    state_option.innerHTML = response.data[abbreviation];
                    state_option.value = abbreviation;
                    state_select.appendChild(state_option);
                } 
            }
            else
            {
                document.getElementById(state_select_id).disabled = true;
            }
        },
        error: function(response) {
            console.error('Error: ', response);
        },
    });
}

function initStripe()
{
    jQuery('[data-target="#editPaymentModal"]').on('click', function(){
        jQuery("input[name='cardId']").val( jQuery(this).data('id') );
        jQuery("#ccNameUpdate").val( jQuery(this).data('name') );

        if( jQuery(this).data('id') == "" )
        {
            jQuery("#editPaymentModalLabel").text( "Add New Payment" );
        }
        else
        {
            jQuery("#editPaymentModalLabel").text( "Edit Payment Method" );
        }
    });

    let style = {
        base: {
            fontSize: '16px',
            color: "#32325d",
        }
    };

    var stripe;
    if (window.location.href.indexOf('local') !== -1 || window.location.href.indexOf('staging') !== -1 || window.location.href.indexOf('account-dev') !== -1) {
        stripe = window.Stripe('pk_test_n3rrzyh2ClIZlnCntL9X8IRx');
    }
    else
    {
        stripe = window.Stripe('pk_live_3L8cvOKHqpOpDF3JXfZqZTd2');
    }
    
    let elements = stripe.elements();

    let card = elements.create('card', {
        'hidePostalCode': true,
        'style': style
    });

    card.mount('#card-element');

    card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) 
        {
            displayError.textContent = event.error.message;
        }
        else 
        {
            displayError.textContent = '';
        }
    });

    jQuery("#editCardForm, #newCustomerCard").on('submit', function(event){
        event.preventDefault();
        var errorElement = jQuery(this).find("#alert-container");

        stripe.createToken(card)
            .then(function(result){
                if(result.error)
                {
                    
                    // Inform the customer that there was an error.
                    
                    jQuery(errorElement).text(result.error.message);
                    jQuery(errorElement).show().addClass("alert-danger");
                }
                else
                {
                    jQuery("input[name='token']").val(result.token.id);

                    jQuery("input[name='cardName']").val( jQuery("#ccNameUpdate").val() );
                    
                    jQuery("#stripetokenForm").submit();
                }
                jQuery("#savePaymentChange").removeAttr('disabled');
            });

            jQuery('.modal-backdrop').css('display', 'block');
    });
}

jQuery("#accountCheckoutModal .ajax_form2, #addCard .ajax_form2, #editShippingAddressModal .ajax_form2").on("submit", function(e){
    e.preventDefault();
    let actionUrl = jQuery(this).attr('action');
    jQuery(".form-error").empty();
    var postData = {};
    for(const field of jQuery(this).serializeArray())
    {
        postData[field.name] = field.value;
    }

    jQuery(this).find('[type="submit"]').first().attr('disabled', 'disabled');

    if (jQuery('#saveNotificationsChange')) {
        jQuery('#saveNotificationsChange').html(`Updating... <div class="spinner-border text-light ml-2" role="status">
        <span class="sr-only">Updating...</span>
      </div>`);
    }

    jQuery('#noCandybarOrdersNotice').hide();

    jQuery('.loading_wrapper').fadeIn();

    var alertContainer = jQuery(this).find("#alert-container");
    submitAjaxForm( actionUrl, postData, alertContainer );
});